import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const AttachmentsIcon = ({
  color, fillOpacity, ...props
}) => (
  <svg
    {...helpers.getSvgDimensionsProps(props)}
    {...props}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.81424 0.416765C8.32861 -0.440967 6.43048 0.0676353 5.57275 1.55327L1.0337 9.41513C-0.125423 11.4228 0.561282 13.9856 2.56894 15.1447C4.57661 16.3039 7.13942 15.6172 8.29855 13.6095L12.5745 6.20337L11.2846 5.45869L7.00871 12.8648C6.26144 14.1591 4.60795 14.6022 3.31363 13.8549C2.01931 13.1076 1.57626 11.4541 2.32354 10.1598L6.86258 2.29796C7.30846 1.52567 8.29727 1.26072 9.06956 1.7066C9.84185 2.15248 10.1068 3.14128 9.66091 3.91357L5.84812 10.5175C5.70363 10.7678 5.37951 10.8546 5.12925 10.7102C4.87899 10.5657 4.79214 10.2416 4.93663 9.99129L8.4863 3.84307L7.19647 3.09839L3.6468 9.2466C3.09046 10.2102 3.42096 11.4437 4.38456 12C5.34817 12.5563 6.58161 12.2258 7.13795 11.2622L10.9507 4.65826C11.8085 3.17262 11.2999 1.2745 9.81424 0.416765Z"
      fill={color}
    />
  </svg>
);

AttachmentsIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

AttachmentsIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(13, 16),
  ...helpers.getViewBoxProperty({ width: 13, height: 16 }),
};

export default AttachmentsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/attachments.js